export default "__VITE_ASSET__CvvHQtr3__"